"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ComponentProps } from "react";

// next-themes renders an inline <script> that sets the theme class before
// paint. React 19.2 warns whenever it creates a <script> on the client, since
// client-created scripts never run. The script only needs to run from the
// server HTML, so on the client mark it as a data block to skip the warning.
const scriptProps = {
  type: typeof window === "undefined" ? "text/javascript" : "application/json",
};

export default function ThemeProvider(
  props: ComponentProps<typeof NextThemesProvider>,
) {
  return <NextThemesProvider scriptProps={scriptProps} {...props} />;
}
